import script from "./Project.vue?vue&type=script&setup=true&lang=js"
export * from "./Project.vue?vue&type=script&setup=true&lang=js"

import "./Project.vue?vue&type=style&index=0&id=71297bd8&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71297bd8"]])

export default __exports__